import React from "react";
import moment from "moment";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { MOMENT_SPANISH_LANG } from "../../../config/defaults";

import "../../../css/survey.css";

import Chart from "./Chart";
import removeAccents from "../../../services/removeAccents";

moment.locale("es", MOMENT_SPANISH_LANG);

class Surveys extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      surveys: [],
      surveyDetails: "none",
    };
    this.getSurveys = this.getSurveys.bind(this);
    this.onDetails = this.onDetails.bind(this);
    this.locateSurvey = this.locateSurvey.bind(this);
    this.setSurveyStatus = this.setSurveyStatus.bind(this);
    this.onDeleteSurvey = this.onDeleteSurvey.bind(this);

    this.listener = [];
  }
  componentDidMount() {
    this.getSurveys();
  }
  componentWillUnmount() {
    for (let listener of this.listener) {
      listener();
    }
  }
  getSurveys() {
    const self = this,
      event_id = this.props.event.id;

    const listener1 = this.props.firebase.getRooms(
      "events",
      event_id,
      "surveys",
      { field: "time", type: "asc" },
      (docs) => {
        const _surveys = [];
        docs.forEach(function (doc) {
          const survey = doc.data();
          survey.id = doc.id;
          _surveys.push(survey);
          const listener = self.props.firebase.getRooms(
            "events",
            event_id,
            "surveys",
            survey.id,
            "answers",
            { field: "time", type: "desc" },
            async (answers) => {
              const votes = {},
                _arr = [];

              const onSuccess = () => {
                const _labels = [],
                  _votes = [];

                survey.options.forEach((option) => {
                  _labels.push(option);
                  _votes.push(votes[option] === undefined ? 0 : votes[option]);
                });

                self.setState({
                  [`survey_${survey.id}`]: {
                    question: survey.question,
                    labels: _labels,
                    data: _votes,
                    details: _arr,
                  },
                });
              };

              let index = 0;

              answers.forEach(async function (answer) {
                let _answer = answer.data();
                if (_answer.name === "") {
                  const user = await self.props.firebase.db
                    .collection("events")
                    .doc(event_id)
                    .collection("subscribers")
                    .where("uid", "array-contains", answer.id)
                    .get();

                  if (!user.empty) {
                    user.forEach((_subscriber) => {
                      _answer.name = _subscriber.data().displayName;
                      _answer.email = _subscriber.data().email;
                    });
                  }
                }
                _arr.push(_answer);
                if (votes[_answer.answer] === undefined) {
                  votes[_answer.answer] = 0;
                }

                votes[_answer.answer]++;

                if (index === answers.size - 1) {
                  onSuccess();
                }
                index++;
              });
            }
          );
          self.listener.push(listener);
        });
        self.setState({ surveys: _surveys, isLoading: false });
      }
    );

    this.listener.push(listener1);
  }
  onDetails(surveyId) {
    if (this.state.surveyDetails !== surveyId) {
      this.setState({ surveyDetails: surveyId });
    }
  }
  locateSurvey(id) {
    const { surveys } = this.state;

    return new Promise((resolve, reject) => {
      for (var idx = 0; idx < surveys.length; idx++) {
        if (surveys[idx].id === id) {
          resolve(idx);
          return false;
        }
      }

      reject();
    });
  }
  setSurveyStatus(id, newStatus) {
    const self = this,
      { surveys } = self.state,
      event_id = this.props.event.id;

    this.props.firebase.subCollection
      .update("events", event_id, "surveys", id, { isActive: newStatus })
      .then(() => {
        self.locateSurvey(id).then((idSurvey) => {
          surveys[idSurvey].isActive = newStatus;
        });
      })
      .catch(() => {});
  }
  onDeleteSurvey(id) {
    const self = this,
      event_id = this.props.event.id;

    swal({
      title: "",
      text: "Se eliminará esta encuesta, esta acción es irreversible, ¿Estas seguro de querer eliminarlar?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        self.props.firebase.subCollection.delete(
          "events",
          event_id,
          "surveys",
          id
        );
      }
    });
  }

  exportToExcel(data, question) {
    const exportData = data.map((row) => ({
      Nombre: row.name,
      Correo: row.email,
      Fecha: row.date,
      Respuesta: row.answer,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Respuestas");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `${removeAccents(question)}.xlsx`);
  }

  render() {
    const { isLoading, surveys, surveyDetails } = this.state;
    if (isLoading) {
      return (
        <React.Fragment>
          <div className="survey-title">
            <h3>Encuestas en vivo</h3>
            <Link to="./new-survey" className="btn btn-outline btn-az-primary">
              Crear una encuesta
            </Link>
          </div>
          <div className="cntEventLoading">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/loading3.gif`}
              alt="loading"
            />
          </div>
        </React.Fragment>
      );
    }

    if (surveyDetails !== "none") {
      const _s = this.state[`survey_${surveyDetails}`],
        _table = [];
      return (
        <React.Fragment>
          <div className="survey-title mg-b-25">
            <h3>{_s.question}</h3>
            <button
              onClick={() => {
                this.onDetails("none");
              }}
              className="btn btn-outline btn-az-primary"
            >
              <i className="fas fa-arrow-left" /> Volver
            </button>
          </div>

          <div className="row">
            <div className="survey-table">
              <table>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>email</th>
                    <th>Fecha y Hora</th>
                    <th>Respuesta</th>
                  </tr>
                </thead>
                <tbody>
                  {_s.details.map((ans, index) => {
                    _table.push({
                      name: ans.name,
                      email: ans.email,
                      date: moment.unix(ans.time).format("YYYY-MM-DD HH:mm:ss"),
                      answer: ans.answer,
                    });
                    return (
                      <tr key={ans.id}>
                        <td>{ans.name}</td>
                        <td>{ans.email}</td>
                        <td>
                          {moment.unix(ans.time).format("YYYY-MM-DD HH:mm:ss")}
                        </td>
                        <td>{ans.answer}</td>
                      </tr>
                    );
                  }, this)}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-12 mg-t-20 tx-right">
            <button
              className="btn btn-az-primary"
              onClick={() => this.exportToExcel(_table, _s.question)}
            >
              <i className="fas fa-file-excel"></i> Exportar todos los
              Registros
            </button>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="survey-title mg-b-25">
          <h3>Encuestas en vivo</h3>
          <Link to="./new-survey" className="btn btn-outline btn-az-primary">
            Crear una encuesta
          </Link>
        </div>
        {surveys.length === 0 && (
          <div className="survey-title">
            <h6>
              Aún no has creado ninguna encuesta,{" "}
              <Link to="./new-survey">empieza aqui</Link>
            </h6>
          </div>
        )}

        <div className="row row-sm row-xl">
          {surveys.map((survey) => {
            const isActive = survey.isActive === true;
            return (
              <div
                className="col-md-6 mg-t-20 mg-sm-t-20 mg-xs-t-20"
                key={survey.question}
              >
                <div className="card card-body card-dashboard-twentythree ht-xl-100p">
                  <div className="survey-header">
                    <h6 className="card-title tx-14 mg-b-10">
                      {survey.question}
                      <br />
                      <br />
                      <span
                        className={
                          "status status-" + (isActive ? "active" : "closed")
                        }
                      >
                        {isActive ? "Abierta" : "Cerrada"}
                      </span>
                    </h6>

                    <div className="options">
                      <button
                        className={
                          "survey-status status-" +
                          (isActive ? "closed" : "active")
                        }
                        onClick={() => {
                          this.setSurveyStatus(survey.id, !isActive);
                        }}
                      >
                        <i
                          className={"fas fa-" + (isActive ? "stop" : "play")}
                        />
                        {isActive ? "Cerrar" : "Iniciar"} encuesta
                      </button>
                      {/*<button className="survey-edit-icon">
                                                <i className="fas fa-edit"/>
                                            </button>*/}
                      <button
                        className="survey-delete-icon"
                        title="Eliminar"
                        onClick={() => {
                          this.onDeleteSurvey(survey.id);
                        }}
                      >
                        <i className="fas fa-times" />
                      </button>
                    </div>
                  </div>
                  <div className="survey-body">
                    {this.state[`survey_${survey.id}`] === undefined && (
                      <i className="fas fa-spinner fa-spin" />
                    )}
                    {this.state[`survey_${survey.id}`] && (
                      <Chart
                        surverId={survey.id}
                        options={survey.options}
                        onDetails={this.onDetails}
                        data={{
                          data: this.state[`survey_${survey.id}`].data,
                          labels: this.state[`survey_${survey.id}`].labels,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          }, this)}
        </div>
      </React.Fragment>
    );
  }
}

export default Surveys;
